// Assumes `xs` is an ascending list of x values. Search for the nearest location
// to `x` in `xs`, and return the corresponding item in y.
export default function nearestItemInArray(xs: number[], x: number) {
  let nextIndexInXs = 1;
  while (nextIndexInXs < xs.length && xs[nextIndexInXs] < x) {
    nextIndexInXs += 1;
  }
  return nextIndexInXs - 1;
}
